export default [
  {
    path: '/ticket/:key?',
    name: 'ticketIndex',
    component: () => import('@/views/ticket/TicketIndex.vue'),
    meta: {},
  },
];
